/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityMelcoModelsError,
    IdentityMelcoModelsErrorFromJSON,
    IdentityMelcoModelsErrorToJSON,
    IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem,
    IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSON,
    IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemToJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemToJSON,
    IdentityMelcoModelsUserPackage,
    IdentityMelcoModelsUserPackageFromJSON,
    IdentityMelcoModelsUserPackageToJSON,
    IdentityMelcoModelsUserPackageListItem,
    IdentityMelcoModelsUserPackageListItemFromJSON,
    IdentityMelcoModelsUserPackageListItemToJSON,
} from '../models';

export interface UserPackageApiUserPackageCreateRequest {
    identityMelcoModelsUserPackage?: IdentityMelcoModelsUserPackage;
}

export interface UserPackageApiUserPackageGetByIdRequest {
    id: string;
}

export interface UserPackageApiUserPackageGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    codeList?: string;
    startDate?: Date;
    endDate?: Date;
    melcoPackageId?: string;
}

/**
 * 
 */
export class UserPackageApi extends runtime.BaseAPI {

    /**
     */
    async userPackageCreateRaw(requestParameters: UserPackageApiUserPackageCreateRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsUserPackageListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/packages/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityMelcoModelsUserPackageToJSON(requestParameters.identityMelcoModelsUserPackage),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsUserPackageListItemFromJSON(jsonValue));
    }

    /**
     */
    async userPackageCreate(requestParameters: UserPackageApiUserPackageCreateRequest): Promise<IdentityMelcoModelsUserPackageListItem> {
        const response = await this.userPackageCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userPackageGetByIdRaw(requestParameters: UserPackageApiUserPackageGetByIdRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsUserPackageListItem>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userPackageGetById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/packages/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsUserPackageListItemFromJSON(jsonValue));
    }

    /**
     */
    async userPackageGetById(requestParameters: UserPackageApiUserPackageGetByIdRequest): Promise<IdentityMelcoModelsUserPackageListItem> {
        const response = await this.userPackageGetByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userPackageGetHistoryRaw(): Promise<runtime.ApiResponse<IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/packages/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItemFromJSON(jsonValue));
    }

    /**
     */
    async userPackageGetHistory(): Promise<IdentityMelcoModelsGenericList1MelcoModelsUserPurchaseListItem> {
        const response = await this.userPackageGetHistoryRaw();
        return await response.value();
    }

    /**
     */
    async userPackageGetListRaw(requestParameters: UserPackageApiUserPackageGetListRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.codeList !== undefined) {
            queryParameters['code_list'] = requestParameters.codeList;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.melcoPackageId !== undefined) {
            queryParameters['melco_package_id'] = requestParameters.melcoPackageId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/packages/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsGenericList1MelcoModelsPaymentListItemFromJSON(jsonValue));
    }

    /**
     */
    async userPackageGetList(requestParameters: UserPackageApiUserPackageGetListRequest): Promise<IdentityMelcoModelsGenericList1MelcoModelsPaymentListItem> {
        const response = await this.userPackageGetListRaw(requestParameters);
        return await response.value();
    }

}
